module.exports = __webpack_public_path__ + "static/topo-blue-b1c5d66a48c8540e65d43964ebfa39d5.svg";